import { Component, useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Programs } from "@/components/Programs";
import { Approach } from "@/components/Approach";
import { Activities } from "@/components/Activities";
import { Testimonials } from "@/components/Testimonials";
import { Franchise } from "@/components/Franchise";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { AdmissionsModal } from "@/components/AdmissionsModal";

class ErrorBoundary extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream p-8 text-center">
          <p className="text-ink/70">Something went wrong. Please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [modal, setModal] = useState(null); // null | "admissions" | "franchise"

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (modal) window.__lenis?.stop();
    else window.__lenis?.start();
  }, [modal]);

  const openModal = (kind = "admissions") => setModal(kind);

  return (
    <ErrorBoundary>
      <div className="relative overflow-x-clip">
        <Nav onEnquire={() => openModal("admissions")} />
        <main>
          <Hero onEnquire={() => openModal("admissions")} />
          <Marquee />
          <About />
          <Programs onEnquire={openModal} />
          <Approach />
          <Activities />
          <Testimonials />
          <Franchise onEnquire={openModal} />
          <Contact />
        </main>
        <Footer />
        <div className="grain-overlay" />
        <AnimatePresence>
          {modal && <AdmissionsModal interest={modal} onClose={() => setModal(null)} />}
        </AnimatePresence>
        <Toaster position="top-center" richColors toastOptions={{ style: { fontFamily: "Outfit, sans-serif" } }} />
      </div>
    </ErrorBoundary>
  );
}

export default App;
